import { ICourseCatalogListingQuery } from '../interfaces/course-catalog-listing.query.interface';
import { RegistrationSettings } from './registration-settings.model';
import { LinkedExecution } from './linked-execution.model';
import { UserExtendedAttributeWithValue } from 'app/projects/user/src/lib/models/user-attribute-with-value';
import { IModuleDuration } from 'app/library/module/interfaces/module-duration.interface';
import { LandingPageComponentListingEventsPreview } from 'app/library/landing-page-component/models/landing-page-component-listing-events-preview.model';
import { LandingPageComponentPermission } from 'app/library/landing-page-component/models/landing-page-component-permission.model';
import { MaxbrainImage } from 'app/library/image-library/models/maxbrain-image.model';

export class CourseCatalogListing {
    id: string;
    courseOffering: {
        id: string;
    };
    registrationSettings: RegistrationSettings | null;
    selfPacedSettings: {
        listedExecutionRule: number;
    } | null;
    attributes: UserExtendedAttributeWithValue[];
    openBookingRequestCount: number;
    approvedBookingRequestCount: number;
    currentUserBookingRequestId: string | null;
    linkedExecution: LinkedExecution | null;
    eventsPreview: LandingPageComponentListingEventsPreview | null;
    name: string;
    version: string;
    startDate: string | null;
    endDate: string | null;
    duration: IModuleDuration | null;
    type: string;
    listingDetailsId?: number;
    permissions: LandingPageComponentPermission[];
    price: { amount: number | null; currency: string } | null;
    requiresApproval: boolean;
    image: MaxbrainImage | null;

    constructor(query: ICourseCatalogListingQuery) {
        this.id = query.id.toString();
        this.courseOffering = {
            id: query.course_offering.id.toString(),
        };
        this.registrationSettings = query.registration_settings ? new RegistrationSettings(query.registration_settings) : null;
        this.selfPacedSettings = query.self_paced_settings
            ? {
                  listedExecutionRule: query.self_paced_settings.listed_execution_rule,
              }
            : null;
        this.attributes = query.attributes ? query.attributes.map((query) => new UserExtendedAttributeWithValue(query.attribute, query.value)) : [];
        this.openBookingRequestCount = query.open_booking_request_count;
        this.approvedBookingRequestCount = query.approved_booking_request_count;
        this.currentUserBookingRequestId =
            query.current_user_booking_request_id !== null && query.current_user_booking_request_id !== undefined ? query.current_user_booking_request_id.toString() : null;
        this.linkedExecution = query.linked_execution ? new LinkedExecution(query.linked_execution) : null;
        this.image = this.linkedExecution?.image ?? null;
        this.eventsPreview = query.events_preview ? new LandingPageComponentListingEventsPreview(query.events_preview) : null;
        this.name = query.name;
        this.version = query.version;
        this.startDate = query.start_date;
        this.endDate = query.end_date;
        this.type = query.type;
        this.listingDetailsId = query.listing_details_id;
        this.permissions = (query.permissions || []).map((permission) => new LandingPageComponentPermission(permission));
        this.price = query.user_pricing ?? null;
        this.requiresApproval = query.requires_approval;
        this.duration = null;

        for (const property in query?.duration) {
            if (query?.duration[property]) {
                this.duration = query?.duration;
            }
        }
    }
}
